<template>
  <div>
    <ValidationObserver ref="experienceDetailsForm">
      <v-row>
        <v-col class="col-md-6 col-12 input-item">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="experience.organisation"
              :error-messages="getErrorMessages(errors)"
              label="Organisation"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-6 col-12 input-item">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
              v-model="experience.jobTitle"
              :error-messages="getErrorMessages(errors)"
              label="Job Title"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-12 input-item py-0">
          <ValidationProvider v-slot="{ errors }" rules="required|max:500">
            <v-textarea
              label="Key Responsibilities"
              v-model="experience.keyResponsibilities"
              :error-messages="getErrorMessages(errors)"
              height="200"
              counter="500"
            />
          </ValidationProvider>
        </v-col>
        <v-col class="col-md-6 col-12 input-item py-0">
          <ValidationProvider v-slot="{ errors }" rules="required|validDate">
            <v-label>Start Date</v-label>
            <v-text-field
              type="text"
              placeholder="dd/mm/yyyy"
              v-mask="'##/##/####'"
              v-model="experience.startDate"
              :error-messages="getErrorMessages(errors)"
              class="mt-2 pt-0"
            />
          </ValidationProvider>
        </v-col>

        <v-col class="col-md-6 col-12 input-item py-0">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="
              `validDate|afterDate:${experience.startDate}|${!presentDate &&
                'required'}`
            "
          >
            <v-label>End Date</v-label>
            <v-text-field
              type="text"
              placeholder="dd/mm/yyyy"
              v-mask="'##/##/####'"
              :value="presentDate ? '' : experience.endDate"
              v-model="experience.endDate"
              :error-messages="getErrorMessages(errors)"
              :readonly="presentDate || !experience.startDate"
              class="mt-2 pt-0"
            />
          </ValidationProvider>
          <v-checkbox
            type="checkbox"
            hide-details
            label="Present"
            v-model="presentDate"
            @change="updateData"
            class="shrink mt-0"
          />
        </v-col>
        <v-col v-if="!presentDate" class="col-12 input-item py-0">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="{ required: !presentDate }"
          >
            <Select
              item-text="name"
              item-value="id"
              v-model="experience.reasonForLeaving"
              label="Reason for leaving"
              placeholder=""
              :items="reasonsForLeaving"
              :error-messages="getErrorMessages(errors)"
              :loading="isFetchingReasonsForLeaving"
              autocomplete
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select from "@/components/common/Select";
import { EXPERIENCE_NAMESPACE } from "@/store/modules/users/experience";
import { FETCH_REASONS_FOR_LEAVING } from "@/store/modules/users/experience/actions";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { formatDate } from "@/utils/time";
import { BASE_DATE_FORMAT } from "@/constants/common";

const { mapActions, mapState: mapExperienceState } = createNamespacedHelpers(
  EXPERIENCE_NAMESPACE
);

const INITIAL_EXPERIENCE = {
  jobTitle: "",
  keyResponsibilities: "",
  organisation: "",
  reasonForLeaving: "",
  startDate: "",
  endDate: ""
};

export default {
  name: "ExperienceDetails",
  components: {
    Select,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    initialData: Object
  },
  data() {
    return {
      experience: { ...INITIAL_EXPERIENCE },
      presentDate: false,
      showValidationErrors: false
    };
  },
  created() {
    if (this.initialData) {
      this.experience = {
        ...this.initialData,
        startDate: formatDate({
          date: this.initialData.startDate,
          endFormat: BASE_DATE_FORMAT
        }),
        endDate: formatDate({
          date: this.initialData.endDate,
          endFormat: BASE_DATE_FORMAT
        })
      };
      if (this.initialData.endDate === "Present") {
        this.presentDate = true;
      }
    }
    this.fetchReasonsForLeaving();
  },
  computed: {
    ...mapExperienceState(
      copyState(["isFetchingReasonsForLeaving", "reasonsForLeaving"])
    )
  },
  methods: {
    ...mapActions({
      fetchReasonsForLeaving: FETCH_REASONS_FOR_LEAVING
    }),
    clearForm() {
      this.showValidationErrors = false;
      this.experience = { ...INITIAL_EXPERIENCE };
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    async validate() {
      this.showValidationErrors = true;
      return this.$refs.experienceDetailsForm.validate();
    },
    getData() {
      return this.experience;
    },
    updateData() {
      if (this.presentDate) {
        this.experience.endDate = null;
        this.experience.reasonForLeaving = null;
      } else {
        this.experience.endDate = null;
      }
    }
  }
};
</script>

<style lang="scss"></style>
